// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2xgwc","footer":"Form_footer__2FE3i"};